import { render, staticRenderFns } from "./OrderDetailsOnDashboard.vue?vue&type=template&id=66e5962a&scoped=true&"
import script from "./OrderDetailsOnDashboard.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsOnDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsOnDashboard.vue?vue&type=style&index=0&id=66e5962a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e5962a",
  null
  
)

export default component.exports